module.exports = __webpack_public_path__ + "68298b74d4caa876a31f5da6cd146b48.png";